/** ----------------------------------------------------------------------
This file is automatically generated by `scripts/globals-extractor.mjs`.
Generated At: 2022-09-03T15:22:37.415Z
---------------------------------------------------------------------- */

export default new Set([
	'AbortController',
	'AbortSignal',
	'AbstractRange',
	'ActiveXObject',
	'AggregateError',
	'AnalyserNode',
	'Animation',
	'AnimationEffect',
	'AnimationEvent',
	'AnimationPlaybackEvent',
	'AnimationTimeline',
	'Array',
	'ArrayBuffer',
	'Atomics',
	'Attr',
	'Audio',
	'AudioBuffer',
	'AudioBufferSourceNode',
	'AudioContext',
	'AudioDestinationNode',
	'AudioListener',
	'AudioNode',
	'AudioParam',
	'AudioParamMap',
	'AudioProcessingEvent',
	'AudioScheduledSourceNode',
	'AudioWorklet',
	'AudioWorkletNode',
	'AuthenticatorAssertionResponse',
	'AuthenticatorAttestationResponse',
	'AuthenticatorResponse',
	'BarProp',
	'BaseAudioContext',
	'BeforeUnloadEvent',
	'BigInt',
	'BigInt64Array',
	'BigUint64Array',
	'BiquadFilterNode',
	'Blob',
	'BlobEvent',
	'Boolean',
	'BroadcastChannel',
	'ByteLengthQueuingStrategy',
	'CDATASection',
	'CSS',
	'CSSAnimation',
	'CSSConditionRule',
	'CSSCounterStyleRule',
	'CSSFontFaceRule',
	'CSSGroupingRule',
	'CSSImportRule',
	'CSSKeyframeRule',
	'CSSKeyframesRule',
	'CSSMediaRule',
	'CSSNamespaceRule',
	'CSSPageRule',
	'CSSRule',
	'CSSRuleList',
	'CSSStyleDeclaration',
	'CSSStyleRule',
	'CSSStyleSheet',
	'CSSSupportsRule',
	'CSSTransition',
	'Cache',
	'CacheStorage',
	'CanvasCaptureMediaStreamTrack',
	'CanvasGradient',
	'CanvasPattern',
	'CanvasRenderingContext2D',
	'ChannelMergerNode',
	'ChannelSplitterNode',
	'CharacterData',
	'ClientRect',
	'Clipboard',
	'ClipboardEvent',
	'ClipboardItem',
	'CloseEvent',
	'Comment',
	'CompositionEvent',
	'ConstantSourceNode',
	'ConvolverNode',
	'CountQueuingStrategy',
	'Credential',
	'CredentialsContainer',
	'Crypto',
	'CryptoKey',
	'CustomElementRegistry',
	'CustomEvent',
	'DOMException',
	'DOMImplementation',
	'DOMMatrix',
	'DOMMatrixReadOnly',
	'DOMParser',
	'DOMPoint',
	'DOMPointReadOnly',
	'DOMQuad',
	'DOMRect',
	'DOMRectList',
	'DOMRectReadOnly',
	'DOMStringList',
	'DOMStringMap',
	'DOMTokenList',
	'DataTransfer',
	'DataTransferItem',
	'DataTransferItemList',
	'DataView',
	'Date',
	'DelayNode',
	'DeviceMotionEvent',
	'DeviceOrientationEvent',
	'Document',
	'DocumentFragment',
	'DocumentTimeline',
	'DocumentType',
	'DragEvent',
	'DynamicsCompressorNode',
	'Element',
	'ElementInternals',
	'Enumerator',
	'Error',
	'ErrorEvent',
	'EvalError',
	'Event',
	'EventCounts',
	'EventSource',
	'EventTarget',
	'External',
	'File',
	'FileList',
	'FileReader',
	'FileSystem',
	'FileSystemDirectoryEntry',
	'FileSystemDirectoryHandle',
	'FileSystemDirectoryReader',
	'FileSystemEntry',
	'FileSystemFileEntry',
	'FileSystemFileHandle',
	'FileSystemHandle',
	'FinalizationRegistry',
	'Float32Array',
	'Float64Array',
	'FocusEvent',
	'FontFace',
	'FontFaceSet',
	'FontFaceSetLoadEvent',
	'FormData',
	'FormDataEvent',
	'Function',
	'GainNode',
	'Gamepad',
	'GamepadButton',
	'GamepadEvent',
	'GamepadHapticActuator',
	'Geolocation',
	'GeolocationCoordinates',
	'GeolocationPosition',
	'GeolocationPositionError',
	'HTMLAllCollection',
	'HTMLAnchorElement',
	'HTMLAreaElement',
	'HTMLAudioElement',
	'HTMLBRElement',
	'HTMLBaseElement',
	'HTMLBodyElement',
	'HTMLButtonElement',
	'HTMLCanvasElement',
	'HTMLCollection',
	'HTMLDListElement',
	'HTMLDataElement',
	'HTMLDataListElement',
	'HTMLDetailsElement',
	'HTMLDialogElement',
	'HTMLDirectoryElement',
	'HTMLDivElement',
	'HTMLDocument',
	'HTMLElement',
	'HTMLEmbedElement',
	'HTMLFieldSetElement',
	'HTMLFontElement',
	'HTMLFormControlsCollection',
	'HTMLFormElement',
	'HTMLFrameElement',
	'HTMLFrameSetElement',
	'HTMLHRElement',
	'HTMLHeadElement',
	'HTMLHeadingElement',
	'HTMLHtmlElement',
	'HTMLIFrameElement',
	'HTMLImageElement',
	'HTMLInputElement',
	'HTMLLIElement',
	'HTMLLabelElement',
	'HTMLLegendElement',
	'HTMLLinkElement',
	'HTMLMapElement',
	'HTMLMarqueeElement',
	'HTMLMediaElement',
	'HTMLMenuElement',
	'HTMLMetaElement',
	'HTMLMeterElement',
	'HTMLModElement',
	'HTMLOListElement',
	'HTMLObjectElement',
	'HTMLOptGroupElement',
	'HTMLOptionElement',
	'HTMLOptionsCollection',
	'HTMLOutputElement',
	'HTMLParagraphElement',
	'HTMLParamElement',
	'HTMLPictureElement',
	'HTMLPreElement',
	'HTMLProgressElement',
	'HTMLQuoteElement',
	'HTMLScriptElement',
	'HTMLSelectElement',
	'HTMLSlotElement',
	'HTMLSourceElement',
	'HTMLSpanElement',
	'HTMLStyleElement',
	'HTMLTableCaptionElement',
	'HTMLTableCellElement',
	'HTMLTableColElement',
	'HTMLTableElement',
	'HTMLTableRowElement',
	'HTMLTableSectionElement',
	'HTMLTemplateElement',
	'HTMLTextAreaElement',
	'HTMLTimeElement',
	'HTMLTitleElement',
	'HTMLTrackElement',
	'HTMLUListElement',
	'HTMLUnknownElement',
	'HTMLVideoElement',
	'HashChangeEvent',
	'Headers',
	'History',
	'IDBCursor',
	'IDBCursorWithValue',
	'IDBDatabase',
	'IDBFactory',
	'IDBIndex',
	'IDBKeyRange',
	'IDBObjectStore',
	'IDBOpenDBRequest',
	'IDBRequest',
	'IDBTransaction',
	'IDBVersionChangeEvent',
	'IIRFilterNode',
	'IdleDeadline',
	'Image',
	'ImageBitmap',
	'ImageBitmapRenderingContext',
	'ImageData',
	'Infinity',
	'InputDeviceInfo',
	'InputEvent',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'InternalError',
	'IntersectionObserver',
	'IntersectionObserverEntry',
	'Intl',
	'JSON',
	'KeyboardEvent',
	'KeyframeEffect',
	'Location',
	'Lock',
	'LockManager',
	'Map',
	'Math',
	'MathMLElement',
	'MediaCapabilities',
	'MediaDeviceInfo',
	'MediaDevices',
	'MediaElementAudioSourceNode',
	'MediaEncryptedEvent',
	'MediaError',
	'MediaKeyMessageEvent',
	'MediaKeySession',
	'MediaKeyStatusMap',
	'MediaKeySystemAccess',
	'MediaKeys',
	'MediaList',
	'MediaMetadata',
	'MediaQueryList',
	'MediaQueryListEvent',
	'MediaRecorder',
	'MediaRecorderErrorEvent',
	'MediaSession',
	'MediaSource',
	'MediaStream',
	'MediaStreamAudioDestinationNode',
	'MediaStreamAudioSourceNode',
	'MediaStreamTrack',
	'MediaStreamTrackEvent',
	'MessageChannel',
	'MessageEvent',
	'MessagePort',
	'MimeType',
	'MimeTypeArray',
	'MouseEvent',
	'MutationEvent',
	'MutationObserver',
	'MutationRecord',
	'NaN',
	'NamedNodeMap',
	'NavigationPreloadManager',
	'Navigator',
	'NetworkInformation',
	'Node',
	'NodeFilter',
	'NodeIterator',
	'NodeList',
	'Notification',
	'Number',
	'Object',
	'OfflineAudioCompletionEvent',
	'OfflineAudioContext',
	'Option',
	'OscillatorNode',
	'OverconstrainedError',
	'PageTransitionEvent',
	'PannerNode',
	'Path2D',
	'PaymentAddress',
	'PaymentMethodChangeEvent',
	'PaymentRequest',
	'PaymentRequestUpdateEvent',
	'PaymentResponse',
	'Performance',
	'PerformanceEntry',
	'PerformanceEventTiming',
	'PerformanceMark',
	'PerformanceMeasure',
	'PerformanceNavigation',
	'PerformanceNavigationTiming',
	'PerformanceObserver',
	'PerformanceObserverEntryList',
	'PerformancePaintTiming',
	'PerformanceResourceTiming',
	'PerformanceServerTiming',
	'PerformanceTiming',
	'PeriodicWave',
	'PermissionStatus',
	'Permissions',
	'PictureInPictureWindow',
	'Plugin',
	'PluginArray',
	'PointerEvent',
	'PopStateEvent',
	'ProcessingInstruction',
	'ProgressEvent',
	'Promise',
	'PromiseRejectionEvent',
	'Proxy',
	'PublicKeyCredential',
	'PushManager',
	'PushSubscription',
	'PushSubscriptionOptions',
	'RTCCertificate',
	'RTCDTMFSender',
	'RTCDTMFToneChangeEvent',
	'RTCDataChannel',
	'RTCDataChannelEvent',
	'RTCDtlsTransport',
	'RTCEncodedAudioFrame',
	'RTCEncodedVideoFrame',
	'RTCError',
	'RTCErrorEvent',
	'RTCIceCandidate',
	'RTCIceTransport',
	'RTCPeerConnection',
	'RTCPeerConnectionIceErrorEvent',
	'RTCPeerConnectionIceEvent',
	'RTCRtpReceiver',
	'RTCRtpSender',
	'RTCRtpTransceiver',
	'RTCSctpTransport',
	'RTCSessionDescription',
	'RTCStatsReport',
	'RTCTrackEvent',
	'RadioNodeList',
	'Range',
	'RangeError',
	'ReadableByteStreamController',
	'ReadableStream',
	'ReadableStreamBYOBReader',
	'ReadableStreamBYOBRequest',
	'ReadableStreamDefaultController',
	'ReadableStreamDefaultReader',
	'ReferenceError',
	'Reflect',
	'RegExp',
	'RemotePlayback',
	'Request',
	'ResizeObserver',
	'ResizeObserverEntry',
	'ResizeObserverSize',
	'Response',
	'SVGAElement',
	'SVGAngle',
	'SVGAnimateElement',
	'SVGAnimateMotionElement',
	'SVGAnimateTransformElement',
	'SVGAnimatedAngle',
	'SVGAnimatedBoolean',
	'SVGAnimatedEnumeration',
	'SVGAnimatedInteger',
	'SVGAnimatedLength',
	'SVGAnimatedLengthList',
	'SVGAnimatedNumber',
	'SVGAnimatedNumberList',
	'SVGAnimatedPreserveAspectRatio',
	'SVGAnimatedRect',
	'SVGAnimatedString',
	'SVGAnimatedTransformList',
	'SVGAnimationElement',
	'SVGCircleElement',
	'SVGClipPathElement',
	'SVGComponentTransferFunctionElement',
	'SVGCursorElement',
	'SVGDefsElement',
	'SVGDescElement',
	'SVGElement',
	'SVGEllipseElement',
	'SVGFEBlendElement',
	'SVGFEColorMatrixElement',
	'SVGFEComponentTransferElement',
	'SVGFECompositeElement',
	'SVGFEConvolveMatrixElement',
	'SVGFEDiffuseLightingElement',
	'SVGFEDisplacementMapElement',
	'SVGFEDistantLightElement',
	'SVGFEDropShadowElement',
	'SVGFEFloodElement',
	'SVGFEFuncAElement',
	'SVGFEFuncBElement',
	'SVGFEFuncGElement',
	'SVGFEFuncRElement',
	'SVGFEGaussianBlurElement',
	'SVGFEImageElement',
	'SVGFEMergeElement',
	'SVGFEMergeNodeElement',
	'SVGFEMorphologyElement',
	'SVGFEOffsetElement',
	'SVGFEPointLightElement',
	'SVGFESpecularLightingElement',
	'SVGFESpotLightElement',
	'SVGFETileElement',
	'SVGFETurbulenceElement',
	'SVGFilterElement',
	'SVGForeignObjectElement',
	'SVGGElement',
	'SVGGeometryElement',
	'SVGGradientElement',
	'SVGGraphicsElement',
	'SVGImageElement',
	'SVGLength',
	'SVGLengthList',
	'SVGLineElement',
	'SVGLinearGradientElement',
	'SVGMPathElement',
	'SVGMarkerElement',
	'SVGMaskElement',
	'SVGMatrix',
	'SVGMetadataElement',
	'SVGNumber',
	'SVGNumberList',
	'SVGPathElement',
	'SVGPatternElement',
	'SVGPoint',
	'SVGPointList',
	'SVGPolygonElement',
	'SVGPolylineElement',
	'SVGPreserveAspectRatio',
	'SVGRadialGradientElement',
	'SVGRect',
	'SVGRectElement',
	'SVGSVGElement',
	'SVGScriptElement',
	'SVGSetElement',
	'SVGStopElement',
	'SVGStringList',
	'SVGStyleElement',
	'SVGSwitchElement',
	'SVGSymbolElement',
	'SVGTSpanElement',
	'SVGTextContentElement',
	'SVGTextElement',
	'SVGTextPathElement',
	'SVGTextPositioningElement',
	'SVGTitleElement',
	'SVGTransform',
	'SVGTransformList',
	'SVGUnitTypes',
	'SVGUseElement',
	'SVGViewElement',
	'SafeArray',
	'Screen',
	'ScreenOrientation',
	'ScriptProcessorNode',
	'SecurityPolicyViolationEvent',
	'Selection',
	'ServiceWorker',
	'ServiceWorkerContainer',
	'ServiceWorkerRegistration',
	'Set',
	'ShadowRoot',
	'SharedArrayBuffer',
	'SharedWorker',
	'SourceBuffer',
	'SourceBufferList',
	'SpeechRecognitionAlternative',
	'SpeechRecognitionErrorEvent',
	'SpeechRecognitionResult',
	'SpeechRecognitionResultList',
	'SpeechSynthesis',
	'SpeechSynthesisErrorEvent',
	'SpeechSynthesisEvent',
	'SpeechSynthesisUtterance',
	'SpeechSynthesisVoice',
	'StaticRange',
	'StereoPannerNode',
	'Storage',
	'StorageEvent',
	'StorageManager',
	'String',
	'StyleMedia',
	'StyleSheet',
	'StyleSheetList',
	'SubmitEvent',
	'SubtleCrypto',
	'Symbol',
	'SyntaxError',
	'Text',
	'TextDecoder',
	'TextDecoderStream',
	'TextEncoder',
	'TextEncoderStream',
	'TextMetrics',
	'TextTrack',
	'TextTrackCue',
	'TextTrackCueList',
	'TextTrackList',
	'TimeRanges',
	'Touch',
	'TouchEvent',
	'TouchList',
	'TrackEvent',
	'TransformStream',
	'TransformStreamDefaultController',
	'TransitionEvent',
	'TreeWalker',
	'TypeError',
	'UIEvent',
	'URIError',
	'URL',
	'URLSearchParams',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray',
	'VBArray',
	'VTTCue',
	'VTTRegion',
	'ValidityState',
	'VarDate',
	'VideoColorSpace',
	'VideoPlaybackQuality',
	'VisualViewport',
	'WSH',
	'WScript',
	'WaveShaperNode',
	'WeakMap',
	'WeakRef',
	'WeakSet',
	'WebAssembly',
	'WebGL2RenderingContext',
	'WebGLActiveInfo',
	'WebGLBuffer',
	'WebGLContextEvent',
	'WebGLFramebuffer',
	'WebGLProgram',
	'WebGLQuery',
	'WebGLRenderbuffer',
	'WebGLRenderingContext',
	'WebGLSampler',
	'WebGLShader',
	'WebGLShaderPrecisionFormat',
	'WebGLSync',
	'WebGLTexture',
	'WebGLTransformFeedback',
	'WebGLUniformLocation',
	'WebGLVertexArrayObject',
	'WebKitCSSMatrix',
	'WebSocket',
	'WheelEvent',
	'Window',
	'Worker',
	'Worklet',
	'WritableStream',
	'WritableStreamDefaultController',
	'WritableStreamDefaultWriter',
	'XMLDocument',
	'XMLHttpRequest',
	'XMLHttpRequestEventTarget',
	'XMLHttpRequestUpload',
	'XMLSerializer',
	'XPathEvaluator',
	'XPathExpression',
	'XPathResult',
	'XSLTProcessor',
	'addEventListener',
	'alert',
	'atob',
	'blur',
	'btoa',
	'caches',
	'cancelAnimationFrame',
	'cancelIdleCallback',
	'captureEvents',
	'clearInterval',
	'clearTimeout',
	'clientInformation',
	'close',
	'closed',
	'confirm',
	'console',
	'createImageBitmap',
	'crossOriginIsolated',
	'crypto',
	'customElements',
	'decodeURI',
	'decodeURIComponent',
	'devicePixelRatio',
	'dispatchEvent',
	'document',
	'encodeURI',
	'encodeURIComponent',
	'escape',
	'eval',
	'event',
	'external',
	'fetch',
	'focus',
	'frameElement',
	'frames',
	'getComputedStyle',
	'getSelection',
	'global',
	'globalThis',
	'history',
	'importScripts',
	'indexedDB',
	'innerHeight',
	'innerWidth',
	'isFinite',
	'isNaN',
	'isSecureContext',
	'length',
	'localStorage',
	'location',
	'locationbar',
	'matchMedia',
	'menubar',
	'moveBy',
	'moveTo',
	'name',
	'navigator',
	'onabort',
	'onafterprint',
	'onanimationcancel',
	'onanimationend',
	'onanimationiteration',
	'onanimationstart',
	'onauxclick',
	'onbeforeprint',
	'onbeforeunload',
	'onblur',
	'oncanplay',
	'oncanplaythrough',
	'onchange',
	'onclick',
	'onclose',
	'oncontextmenu',
	'oncuechange',
	'ondblclick',
	'ondevicemotion',
	'ondeviceorientation',
	'ondrag',
	'ondragend',
	'ondragenter',
	'ondragleave',
	'ondragover',
	'ondragstart',
	'ondrop',
	'ondurationchange',
	'onemptied',
	'onended',
	'onerror',
	'onfocus',
	'onformdata',
	'ongamepadconnected',
	'ongamepaddisconnected',
	'ongotpointercapture',
	'onhashchange',
	'oninput',
	'oninvalid',
	'onkeydown',
	'onkeypress',
	'onkeyup',
	'onlanguagechange',
	'onload',
	'onloadeddata',
	'onloadedmetadata',
	'onloadstart',
	'onlostpointercapture',
	'onmessage',
	'onmessageerror',
	'onmousedown',
	'onmouseenter',
	'onmouseleave',
	'onmousemove',
	'onmouseout',
	'onmouseover',
	'onmouseup',
	'onoffline',
	'ononline',
	'onorientationchange',
	'onpagehide',
	'onpageshow',
	'onpause',
	'onplay',
	'onplaying',
	'onpointercancel',
	'onpointerdown',
	'onpointerenter',
	'onpointerleave',
	'onpointermove',
	'onpointerout',
	'onpointerover',
	'onpointerup',
	'onpopstate',
	'onprogress',
	'onratechange',
	'onrejectionhandled',
	'onreset',
	'onresize',
	'onscroll',
	'onsecuritypolicyviolation',
	'onseeked',
	'onseeking',
	'onselect',
	'onselectionchange',
	'onselectstart',
	'onslotchange',
	'onstalled',
	'onstorage',
	'onsubmit',
	'onsuspend',
	'ontimeupdate',
	'ontoggle',
	'ontouchcancel',
	'ontouchend',
	'ontouchmove',
	'ontouchstart',
	'ontransitioncancel',
	'ontransitionend',
	'ontransitionrun',
	'ontransitionstart',
	'onunhandledrejection',
	'onunload',
	'onvolumechange',
	'onwaiting',
	'onwebkitanimationend',
	'onwebkitanimationiteration',
	'onwebkitanimationstart',
	'onwebkittransitionend',
	'onwheel',
	'open',
	'opener',
	'orientation',
	'origin',
	'outerHeight',
	'outerWidth',
	'pageXOffset',
	'pageYOffset',
	'parent',
	'parseFloat',
	'parseInt',
	'performance',
	'personalbar',
	'postMessage',
	'print',
	'process',
	'prompt',
	'queueMicrotask',
	'releaseEvents',
	'removeEventListener',
	'reportError',
	'requestAnimationFrame',
	'requestIdleCallback',
	'resizeBy',
	'resizeTo',
	'screen',
	'screenLeft',
	'screenTop',
	'screenX',
	'screenY',
	'scroll',
	'scrollBy',
	'scrollTo',
	'scrollX',
	'scrollY',
	'scrollbars',
	'self',
	'sessionStorage',
	'setInterval',
	'setTimeout',
	'speechSynthesis',
	'status',
	'statusbar',
	'stop',
	'structuredClone',
	'toString',
	'toolbar',
	'top',
	'undefined',
	'unescape',
	'visualViewport',
	'webkitURL',
	'window'
]);
